var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStethoscopeIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.453 429.453",
    style: {
      enableBackground: "new 0 0 429.453 429.453"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A2C51"
    },
    d: "M326.008,258.09v61.649c0,20.898-8.359,40.229-23.51,55.38 c-14.106,14.629-33.959,22.988-54.857,22.988c-43.363,0-78.367-35.004-78.367-78.367v-88.294 c28.212-3.135,54.857-16.196,74.71-36.049c23.51-23.51,36.571-54.857,36.571-88.816V32.392c0-8.882-6.792-15.673-15.673-15.673 h-33.959v31.347h18.286v58.514c0,25.6-9.927,49.11-27.167,66.873c-17.763,17.763-41.796,27.69-66.873,27.69 c-51.722,0-94.041-42.318-94.041-94.041V48.065h17.241V16.718H45.453c-8.882,0-15.673,6.792-15.673,15.673v74.71 c0,63.216,47.02,115.984,108.147,124.343v88.294c0,60.604,49.11,109.714,109.714,109.714c29.78,0,57.469-11.494,77.322-32.392 c20.898-20.898,32.392-48.065,32.392-77.322V258.09c-5.224,1.567-10.449,2.09-15.673,2.09S331.233,259.135,326.008,258.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DCFE0"
    },
    d: "M399.673,204.8c0-31.869-26.122-57.992-57.992-57.992S283.69,172.931,283.69,204.8 c0,26.645,17.763,49.11,42.318,55.902c5.224,1.567,10.449,2.09,15.673,2.09s10.449-1.045,15.673-2.09 C381.91,253.91,399.673,231.445,399.673,204.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BBD3"
    },
    d: "M76.278,49.11c0,8.882,6.792,15.673,15.673,15.673s15.673-6.792,15.673-15.673V15.673 C107.624,6.792,100.833,0,91.951,0S76.278,6.792,76.278,15.673v1.045v31.347V49.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BBD3"
    },
    d: "M233.012,15.673C233.012,6.792,226.22,0,217.339,0s-15.673,6.792-15.673,15.673V49.11 c0,8.882,6.792,15.673,15.673,15.673s15.673-6.792,15.673-15.673v-1.045V16.718V15.673z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeIconLight);
export default __webpack_public_path__ + "static/media/StethoscopeIconLight.9d1ae8eb.svg";
export { ForwardRef as ReactComponent };